import { render, staticRenderFns } from "./StopFeedbackDialog.vue?vue&type=template&id=57f01f53&"
import script from "./StopFeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./StopFeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f01f53')) {
      api.createRecord('57f01f53', component.options)
    } else {
      api.reload('57f01f53', component.options)
    }
    module.hot.accept("./StopFeedbackDialog.vue?vue&type=template&id=57f01f53&", function () {
      api.rerender('57f01f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/StopFeedbackDialog.vue"
export default component.exports